module.exports = __webpack_public_path__ + "img/cloud-03.77f1406b.svg";